import { render, staticRenderFns } from "./LayoutForm.vue?vue&type=template&id=5d8796dc&"
import script from "./LayoutForm.vue?vue&type=script&lang=js&"
export * from "./LayoutForm.vue?vue&type=script&lang=js&"
import style0 from "./LayoutForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports